import { Message } from 'element-ui';

/**
 * 数字千分位处理
 * @param {Number} num 传入的数字
 * @returns 千分位处理后的数字
 */
export function num(num) {
  console.log(num);
  let str = parseFloat(Number(num).toFixed(1)); //去除多余的小数、抹掉小数点后面多余的0
  str = str + '';
  if (!str.includes('.')) {
    str += '.';
  }
  return str
    .replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
      return $1 + ' ';
    })
    .replace(/\.$/, '');
}

/**
 *
 * @param {obj} res 接口返回的数据
 * @returns Toast 状态
 */
export function Toast(res) {
  if (res.status == 401) {
    return;
  }
  if (res.status == 1) {
    Message.success({ message: res.info, center: true });
  } else {
    Message.error({ message: res.info, center: true });
  }
}
/**
 * 手机号加密
 * @param {String} res 传入的手机号
 * @returns 加密后的手机号
 */
export function encryption(res) {
  // console.log(res);
  let phone = '';
  for (let index = 0; index < res.length; index++) {
    // console.log(res.charAt(index));
    if (index > 2 && index < res.length - 3) {
      phone = phone + '*';
    } else {
      phone = phone + res.charAt(index);
    }
  }

  return phone;
}

export function calculatingTime(number) {
  console.log(number);
  var date = new Date(number * 1000);
  var year = date.getFullYear(); //获取完整的年份(4位,1970-????)
  console.log(year);
  var month = date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
  console.log(month);
  var day = date.getDate(); //获取当前日(1-31)
  console.log(day);
  var hours = date.getHours(); //获取当前小时数(0-23)
  var minutes = date.getMinutes(); //获取当前分钟数(0-59)
  var seconds = date.getSeconds(); //获取当前秒数(0-59)
  return makeUp(day) + '-' + makeUp(month) + '-' + year + ' ' + makeUp(hours) + ':' + makeUp(minutes) + ':' + makeUp(seconds);
}

function makeUp(m) {
  return m < 10 ? '0' + m : m;
}
